<template>
  <div ref="reportrange" class="date-range-picker">
    <span class="btn btn-sm border"><i class="fa fa-calendar-days"></i>{{ dateRangeText }}</span>
  </div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import 'daterangepicker'

export default {
  name: 'DateRange',
  props: ['start', 'end'],
  data () {
    return {
      dateRangeText: '',
      startDate: '',
      endDate: ''
    }
  },
  mounted () {
    this.startDate = this.start ? moment(this.start) : moment().subtract(29, 'days')
    this.endDate = this.end ? moment(this.end) : moment()
    this.initializeDateRangePicker()
  },
  methods: {
    initializeDateRangePicker () {
      const $element = $(this.$refs.reportrange)
      const updateDateText = (start, end) => {
        this.dateRangeText = `${start.format('MMMM D, YYYY')} - ${end.format('MMMM D, YYYY')}`
      }

      $element.daterangepicker({
        startDate: this.startDate,
        endDate: this.endDate,
        ranges: {
          [this.$t('today')]: [moment(), moment()],
          [this.$t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [this.$t('last_seven_days')]: [moment().subtract(6, 'days'), moment()],
          [this.$t('last_thirty_days')]: [moment().subtract(29, 'days'), moment()],
          [this.$t('this_month')]: [moment().startOf('month'), moment().endOf('month')],
          [this.$t('last_month')]: [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month')
          ]
        },
        locale: {
          format: 'MMMM D, YYYY',
          separator: ' - ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          customRangeLabel: 'Personalizado'
        },
        applyButtonClasses: 'btn-color10'
      }, (start, end) => {
        updateDateText(start, end)
        this.startDate = start
        this.endDate = end
        const date = {
          start: start.format('YYYY-MM-DD'),
          end: end.format('YYYY-MM-DD')
        }
        this.$emit('date-filter', date)
      })
      updateDateText(this.startDate, this.endDate)
    }
  }
}
</script>

<style scoped>
  .date-range-picker {
    cursor: pointer;
    max-width: 400px;
  }
  .date-range-picker i {
    margin-right: 5px;
  }
</style>
